<div *ngIf="validateFundingDetails$ | async as _validateFundingDetails">
	<div
		class="flex flex-row align-middle items-baseline mx-4 justify-between py-6"
	>
		<div class="flex flex-row space-x-4 items-center align-middle">
			<div
				*ngIf="_validateFundingDetails?.missingFields?.length > 0"
				class="flex flex-row space-x-2 items-center align-middle"
			>
				<div class="space-x-2 cursor-pointer" (click)="toggleContainer()">
					<app-icon [icon]="ICON.WARNING" class="text-orange-500"></app-icon>
					<span class="text-sm font-normal text-gray-700"
						>Actions Required</span
					>
				</div>
				<span class="text-sm font-normal text-gray-500"
					>Confirm how the mortgage will be funded.</span
				>
			</div>
		</div>
		<div class="items-end cursor-pointer" (click)="toggleContainer()">
			<ui-button
				icon="chevron-down"
				size="sm"
				[preset]="BUTTON_PRESETS.ICON_DEFAULT"
				[flipIcon]="isOpened"
			/>
		</div>
	</div>
	<div class="space-y-4" *ngIf="isOpened" [@openClose]>
		<div class="flex flex-col flex-1">
			<div class="flex flex-row h-full border-t">
				<div class="p-6 w-full">
					<div
						*ngIf="
							_validateFundingDetails?.missingFields?.length > 0;
							else allGood
						"
					>
						<div class="flex flex-col space-y-2">
							<div>Confirm Funding Details</div>
							<span class="text-xs max-w-[720px]">
								Select preferred funding details for this mortgage (i.e.
								electronic transfer or cheque, branch pickup, trust account to
								deposit to, etc.) based on options supported by the particular
								lender.
							</span>
							<span class="text-green-600 text-base font-medium"
								>Confirm funding details</span
							>
						</div>
					</div>
				</div>
				<div class="w-fit h-52 flex items-center align-middle">
					<img
						class="w-[300px] mx-auto"
						src="/assets/images/mortgage/mortgge-stepper.svg"
						alt="Funding Option"
					/>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #allGood>
	<div
		class="flex flex-col items-center justify-center space-y-6 m-auto w-10/12"
		*ngIf="mortgage$ | async as mortgage"
	>
		<i-tabler name="sun-high" class="w-10 h-10 text-green-600" />

		<ng-container [ngSwitch]="mortgage?.fundingDetails?.type">
			<ng-container *ngSwitchCase="fundingType.WIRE_TRANSFER">
				<p>
					You're all set! You've selected
					{{ mortgage?.fundingDetails?.trustAccount?.nickname }}
					{{ mortgage?.fundingDetails?.trustAccount?.payeeName }} as the trust
					deposit account. Select "Confirm Details" above to proceed to Step 3:
					Request for Funds.
				</p>
			</ng-container>
			<ng-container *ngSwitchCase="fundingType.BRANCH_PICKUP">
				<p>
					You're all set! You've selected
					{{ mortgage?.fundingDetails?.localBranch?.name }} -
					{{ mortgage?.fundingDetails?.localBranch?.address | address }} as the
					pickup location. Select "Confirm Details" above to proceed to Step 3:
					Request for Funds.
				</p>
			</ng-container>
			<ng-container *ngSwitchCase="fundingType.NO_FUNDING_REQUIRED">
				<p>
					You're all set! No Funding Options needed for this mortgage. Select
					"Confirm Details" above to proceed to Step 3: Request for Funds.
				</p>
			</ng-container>
		</ng-container>
	</div>
</ng-template>
